import { createAction } from "@reduxjs/toolkit"

export const getChartUsingWalletAsync = createAction(
   "chartUsingWallet/getChartUsingWalletDataAsync"
)

export const exportExcelChartUsingWalletAsync = createAction<any>(
   "chartUsingWallet/exportExcelChartUsingWalletAsync"
)
